var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71875 15.2188C5.51042 15.4062 5.27083 15.5 5 15.5C4.72917 15.5 4.48958 15.4062 4.28125 15.2188C4.09375 14.9896 4 14.75 4 14.5C4 14.25 4.09375 14.0104 4.28125 13.7812L12.5938 5.5H9C8.70833 5.5 8.46875 5.40625 8.28125 5.21875C8.09375 5.03125 8 4.79167 8 4.5C8 4.20833 8.09375 3.96875 8.28125 3.78125C8.46875 3.59375 8.70833 3.5 9 3.5H15C15.0833 3.5 15.2083 3.52083 15.375 3.5625C15.7917 3.72917 16 4.04167 16 4.5V10.5C16 10.7917 15.9062 11.0312 15.7188 11.2188C15.5312 11.4062 15.2917 11.5 15 11.5C14.7083 11.5 14.4688 11.4062 14.2812 11.2188C14.0938 11.0312 14 10.7917 14 10.5V6.90625L5.71875 15.2188Z",
    fill: "#005EB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartures);
export default __webpack_public_path__ + "static/media/departures.77cb285c17d22562b610cf7462fd4ca1.svg";
export { ForwardRef as ReactComponent };